import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SDK from "../config";
import TrackingScripts from "../Components/checkoutPageComponent/trackingComponent";
import postVisitorsData from "../Components/web/visitors";
import { images } from "../Constants/imageslinks.js";
import Header from "../Components/ui/header.jsx";
import MenuComponent from "../Components/reservationPageComponents/menuComponent.jsx";
import Footer from "../Components/ui/footer.jsx";
import SubscriptionService from "../services/subscriptionService";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Components/Loader/loader";

const ReservationPage = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const email = params.get("email");
  const navigate = useNavigate();
  const eventId = `event-${new Date().getTime()}`;
  // const saveRegion = localStorage.getItem("region") || "us";
  const [pageLoader, setPageLoader] = useState(false);
  const [currRegion, setCurrRegion] = useState("");
  const DiscountedPrice = SDK.FB_PRICE - SDK.FB_DISOUNT_PRICE;
  const finalDiscountedPrice = Number(DiscountedPrice.toFixed(2));
  const monthlyPrice = process.env.REACT_APP_MONTHLY_PRICE_SUBSCRIPTION;
  const yearlyPrice = process.env.REACT_APP_YEARLY_PRICE_SUBSCRIPTION;
  const lifetimePrice = process.env.REACT_APP_LIFETIME_SUBSCRIPTION;
  const initialPlan = {
    type: "Annual",
    pageType: "subscription",
    price: Number(yearlyPrice),
  };
  const [selectedPlan, setSelectedPlan] = useState(initialPlan);
  useEffect(() => {
    if (!email) {
      navigate("/");
    }
  }, [email, navigate]);

  useEffect(() => {
    const planInStorage = localStorage.getItem("selectedPlan");
    if (!planInStorage) {
      localStorage.setItem("selectedPlan", JSON.stringify(initialPlan));
    }

    if (window.mootrack) {
      window.mootrack("Reservation Page", email);
    }

    // Lead Generation Tracker
    if (window.twq) {
      window.twq("event", "tw-qmokf-qmokh", {
        email_address: email,
      });
    }
    const region = localStorage.getItem("region");
    if (region === "uk" || region === "eu") {
      setCurrRegion(`${region}`);
    } else {
      setCurrRegion("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const clickCountMeIn = async () => {
    const selectedPlan = SDK.getSelectedPlan();
    if (!selectedPlan) {
      toast.error("No plan selected.");
      return;
    }
    setPageLoader(true);

    try {
      if (selectedPlan.pageType === "subscription") {
        const response = await SubscriptionService.checkSubscriptionStatus(
          email
        );
        if (response) {
          toast.error(
            "This email has an active subscription. Please change the email address."
          );
          return;
        }
      }
      // Tracking events
      if (window.fbq) window.fbq("track", "AddToCart", { event_id: eventId });
      if (window.mootrack) window.mootrack("AddToCart", email);
      // if (window.ttq) window.ttq.track("AddToCart", { event_id: eventId });
      if (window.twq)
        window.twq("event", "tw-qmokf-qmokj", { value: 5.0, currency: "USD" });

      // Post visitor data
      postVisitorsData({
        email,
        lead: true,
        addtocart: true,
        purchase: false,
        amount: null,
        tags: "ios Website",
      });

      // Navigate to checkout
      const pathToNav =
        currRegion !== ""
          ? `/${currRegion}/payment-checkout?email=${encodeURIComponent(email)}`
          : `/payment-checkout?email=${encodeURIComponent(email)}`;

      navigate(pathToNav);
    } catch (error) {
      console.error("Error in clickCountMeIn:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setPageLoader(false);
    }
  };

  return (
    <Fragment>
      <TrackingScripts />
      <div>
        <div className="bg-primary200">
          <div className="lg:hidden">
            <Header />
          </div>
          <div className="3xl:container 3xl:mx-auto bg-primary300 lg:grid grid-cols-12 flex flex-col-reverse">
            <div className="lg:min-h-screen lg:px-[7vw] md:px-8 px-4 3xl:px-[110px] col-span-7">
              <div className="py-[45px] hidden lg:block">
                <img src={images.minimis_logo} alt="minimis logo" />
              </div>

              <div className="flex flex-col items-start md:gap-[37px] gap-6 md:pt-[20px] pt-[30px] pb-[30px]">
                <p className="font-light text-[32px] leading-12 text-secondary100">
                  Welcome!{" "}
                  {/* Get 40% off your first year for{" "}
                  {regionText.currSymbol ?? "$"}
                  {finalDiscountedPrice}
                  &nbsp;
                  {(regionText.currency ?? "USD").toUpperCase()} */}
                </p>
                <div className="font-normal text-base leading-6 text-secondary100 flex flex-col gap-[18px]">
                  <p>
                    Today’s your lucky day! We charge $49.99 yearly on the app
                    store.
                  </p>
                  <p>
                    For less than a cup of coffee, save up to 120 hours every
                    month.
                  </p>
                  <p>
                    Get a dumbphone experience for a fraction of the cost,
                    without sacrificing the utility of your smartphone or
                    needlessly polluting the environment.
                  </p>
                </div>

                <div className="max-w-[415px] w-full flex flex-col gap-2">
                  <div
                    className={`flex gap-[10px] items-start w-full bg-primary700 rounded-lg border-[2px] p-4 cursor-pointer ${
                      selectedPlan?.type === "Monthly"
                        ? "border-black"
                        : "border-gray-300"
                    }`}
                    onClick={() => {
                      const plan = {
                        type: "Monthly",
                        pageType: "subscription",
                        price: Number(monthlyPrice),
                      };
                      setSelectedPlan(plan); // Update state
                      SDK.setSelectedPlan(plan);
                    }}
                  >
                    <img src={images.payment_option_icon} alt="payment icon" />
                    <div className="flex flex-col gap-[6px]">
                      <p className="font-semibold text-base text-secondary300 leading-[1]">
                        Monthly
                      </p>
                      <p className="font-normal text-sm text-secondary400 leading-[1]">
                        ${monthlyPrice} / Month
                      </p>
                    </div>
                  </div>
                  <div
                    className={`relative flex gap-[10px] items-start w-full bg-primary700 rounded-lg border-[2px] p-4  cursor-pointer ${
                      selectedPlan?.type === "Annual"
                        ? "border-secondary100"
                        : "border-gray-300"
                    }`}
                    onClick={() => {
                      const plan = {
                        type: "Annual",
                        pageType: "subscription",
                        price: Number(yearlyPrice),
                      };
                      setSelectedPlan(plan);
                      SDK.setSelectedPlan(plan);
                    }}
                  >
                    <img src={images.payment_option_icon} alt="payment icon" />
                    <div className=" flex flex-col gap-[6px]">
                      <p className="font-semibold text-base text-secondary300 leading-[1] flex gap-[6px]">
                        Annual{" "}
                        <span className="text-paymentGreen100">(Save 52%)</span>
                      </p>
                      <p className="font-normal text-sm text-secondary400 leading-[1]">
                        ${yearlyPrice} / Year
                      </p>
                    </div>
                    <p className="absolute -right-[5px] -top-[5px] rounded p-2 bg-paymentGreen100 font-semibold text-sm text-primary100 leading-[18px] whitespace-nowrap">
                      Most popular
                    </p>
                  </div>
                  <div
                    className={`flex gap-[10px] items-start w-full bg-primary700 rounded-lg border-[2px] p-4 cursor-pointer ${
                      selectedPlan?.type === "Lifetime"
                        ? "border-black"
                        : "border-gray-300"
                    }`}
                    onClick={() => {
                      const plan = {
                        type: "Lifetime",
                        pageType: "lifetime",
                        price: Number(lifetimePrice),
                      };
                      setSelectedPlan(plan);
                      SDK.setSelectedPlan(plan);
                    }}
                  >
                    <img src={images.payment_option_icon} alt="payment icon" />
                    <div className="flex flex-col gap-[6px]">
                      <p className="font-semibold text-base text-secondary300 leading-[1]">
                        Lifetime <span>(save 71%)</span>
                      </p>
                      <p className="font-normal text-sm text-secondary400 leading-[1]">
                        ${lifetimePrice} / Life
                      </p>
                    </div>
                  </div>
                </div>

                <button
                  onClick={clickCountMeIn}
                  disabled={selectedPlan.type === null}
                  className={`w-full max-w-[415px] rounded-sm font-medium text-base leading-[100%] text-primary100 p-3 ${
                    // Conditional styling for enabled/disabled state
                    selectedPlan.type === null
                      ? "bg-secondary100 cursor-not-allowed" // Disabled style
                      : "bg-secondary100" // Enabled style
                  }`}
                >
                  Get access
                </button>
              </div>
            </div>

            <MenuComponent />
          </div>

          <div className="px-5 py-5 flex flex-col gap-4 lg:hidden">
            <div className="bg-primary100 rounded-lg p-6 flex gap-3 items-start">
              <img src={images.hands_icon} alt="refund icon" />
              <div className="flex flex-col gap-3">
                <p className="font-light md:text-2xl text-lg md:leading-[100%] leading-[25px] text-secondary100">
                  7-day full refund guarantee
                </p>
                <p className="font-light md:text-base text-sm md:leading-[21px] leading-[19px] text-secondary100 max-w-[537px]">
                  Not a fan? No problem. Email us for a full refund within 7
                  days of purchase.
                </p>
              </div>
            </div>
            <div className="bg-primary100 rounded-lg p-6 flex gap-3 items-start">
              <img src={images.payment_icon} alt="refund icon" />
              <div className="flex flex-col gap-3">
                <p className="font-light md:text-2xl text-lg md:leading-[100%] leading-[25px] text-secondary100">
                  Payment secured by Stripe
                </p>
                <p className="font-light md:text-base text-sm md:leading-[21px] leading-[19px] text-secondary100 max-w-[530px]">
                  The same payment processor Apple, Amazon, Etsy, Walmart &
                  Target use. No credit card details seen or stored by us!
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </Fragment>
  );
};

export default ReservationPage;
